<main id="agreement" class="detail">
    <header>
        <div class="nav">
            <h1>{{_('agreement_title')}}</h1>
            <span class="icon back" @click="back()"> chevron_left </span>
        </div>
    </header>
    <section class="navigation">
        <h3>{{_('agreement_sub_title')}}</h3>
    </section>
    <div class="guide">
        {{_(app.house.agreement_method ? 'agreement_sign_guide' :
        'agreement_check_guide')}}
    </div>
    <pre class="description">{{_(app.house.tsandcs)}}</pre>

    <div class="detail_guide">
        <a
            v-if="app.agreement_tsandcs_url"
            :href="app.agreement_tsandcs_url"
            target="_blank"
        >
            {{_('detail_guide')}}
        </a>
    </div>

    <div v-if="requireSign()" class="start_sign" @click="startSign()">
        <template v-if="signatureSVG">
            <p>{{_('signature_frame')}}</p>
            <svg
                v-html="signatureSVG"
                :viewBox="svgViewBox"
                xmlns="http://www.w3.org/2000/svg"
            ></svg>
        </template>
        <button v-else>{{_('start_sign')}}</button>
    </div>
    <div v-else class="agreement_touch">
        <label>
            <input hidden type="checkbox" v-model="checkedAgreement" />
            <p></p>
            <span>{{_('register_I_agree')}}</span>
        </label>
    </div>
    <button class="go-next" @click="goNext()">{{_('go_next')}}</button>

    <div class="pop" v-show="drawing">
        <div class="content">
            <h3 before-icon="edit">{{_('please_sign')}}</h3>
            <section>
                <svg
                    :viewBox="svgViewBox"
                    ref="drawArea"
                    xmlns="http://www.w3.org/2000/svg"
                ></svg>
            </section>
            <hr />
            <div class="flex-buttons">
                <button @click="decideSign()">{{_('decide')}}</button>
                <button class="skeleton" @click="drawer.clear()">
                    {{_('clear')}}
                </button>
            </div>
        </div>
        <div class="shadow" @click="drawing = false"></div>
    </div>
</main>
